/**
 * Moved from `src/hooks/query/useQuerySessionFeedback.ts` (now a delegate)
 * with the D6 family. One input hoisted per the W3c pattern: the current
 * session id came from `useCurrentIds` (route-derived app composition, design
 * D2f) — the delegate reads it and passes `sessionId` in.
 */
import { useQuery } from '@tanstack/react-query';
import { SESSION_FEEDBACK_QUERY_KEY } from '../../contracts';
import { getFeedbackV2 } from '../api/feedback';
import { getSessionDataConfig } from '../config';

export function useQuerySessionFeedback(sessionId: string) {
  return useQuery({
    enabled: !!sessionId,
    refetchOnMount: 'always',
    queryKey: [SESSION_FEEDBACK_QUERY_KEY, sessionId],
    queryFn: async () => {
      return (await getFeedbackV2(sessionId)).data;
    },
  });
}

export function invalidateSessionFeedback(sessionId: string) {
  return getSessionDataConfig()
    .getQueryClient()
    .invalidateQueries({
      queryKey: [SESSION_FEEDBACK_QUERY_KEY, sessionId],
    });
}
